export default __webpack_public_path__ + "static/media/CERT5.43d62f1b.png";